import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import { AspectRatio } from '../AspectRatio/AspectRatio';
import HoverableImage from '../HoverableImage';
import SubscribeBell from '../SubscribeBell';

interface Props {
  className?: string;
  href: string;
  image: {
    alt: string;
    eagerLoading?: boolean;
    focus?: string;
    hoverSrc?: string;
    src: string;
  };
  name: string;
  onClick?: () => void;
  onClickSubscribe?: () => Promise<void>;
  overline?: string;
  isSubscribed: boolean;
  subtitle?: string;
}

export const ArtistProfileCard: FC<Props> = ({
  className = '',
  href,
  image,
  isSubscribed,
  name,
  onClick,
  onClickSubscribe,
  overline,
  subtitle,
}) => (
  <div className="relative">
    <Link
      className={classNames('group flex flex-col space-y-3', className)}
      href={href}
      onClick={onClick}
      prefetch={false}
    >
      <AspectRatio sm="1/1">
        <div className="overflow-hidden rounded-sm">
          <HoverableImage
            alt={image.alt}
            eagerLoading={Boolean(image.eagerLoading)}
            focus={image.focus}
            hoverEffect
            hoverImageSrc={image.hoverSrc}
            size={{
              sm: { ratio: '1/1', span: 6 },
              md: { ratio: '1/1', span: 3 },
              lg: { ratio: '1/1', span: 4 },
            }}
            src={image.src}
          />
        </div>
      </AspectRatio>
      <div className="flex flex-col">
        <h3 className="font-bold transition-colors duration-300 group-hover:text-neutral-4">
          {name}
        </h3>
        {subtitle && (
          <p className="transition-colors duration-300 group-hover:text-neutral-4">
            {subtitle}
          </p>
        )}
      </div>
      {overline && (
        <p className="text-neutral-4 transition-colors duration-300 group-hover:text-neutral-4">
          {overline}
        </p>
      )}
    </Link>
    {onClickSubscribe && (
      <div className="absolute right-4 top-4">
        <SubscribeBell
          isSubscribed={isSubscribed}
          onClickSubscribe={onClickSubscribe}
        />
      </div>
    )}
  </div>
);
